function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M404.39,666.82h-7a.65.65,0,0,1-.6-.6.37.37,0,0,1,.1-.3l1.2-2.3a.55.55,0,0,1,.5-.3h4.7a.55.55,0,0,1,.5.3l1.2,2.3a.67.67,0,0,1-.3.8C404.59,666.72,404.49,666.82,404.39,666.82Zm-6.1-1.2h5.1l-.6-1.2h-4Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405,670.32h-8.2a.65.65,0,0,1-.6-.6v-2.3a.37.37,0,0,1,.1-.3l.6-1.2a.55.55,0,0,1,.5-.3h7a.55.55,0,0,1,.5.3l.6,1.2c0,.1.1.2.1.3v2.3A.65.65,0,0,1,405,670.32Zm-7.6-1.2h7v-1.6l-.4-.7h-6.3l-.4.7v1.6Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M397.39,666.22h-1.2a.6.6,0,0,1,0-1.2h1.2a.6.6,0,0,1,0,1.2Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M398.59,668.52h-1.8a.6.6,0,0,1,0-1.2h1.8a.6.6,0,0,1,0,1.2Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405,668.52h-1.7a.6.6,0,0,1,0-1.2h1.8a.65.65,0,0,1,.6.6C405.69,668.22,405.29,668.52,405,668.52Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405.59,666.22h-1.2a.6.6,0,1,1,0-1.2h1.2a.6.6,0,0,1,0,1.2Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M398.59,672h-1.8a.65.65,0,0,1-.6-.6v-1.8a.65.65,0,0,1,.6-.6h1.8a.65.65,0,0,1,.6.6v1.8A.58.58,0,0,1,398.59,672Zm-1.2-1.1h.6v-.6h-.6Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405,672h-1.7a.65.65,0,0,1-.6-.6v-1.8a.65.65,0,0,1,.6-.6h1.8a.65.65,0,0,1,.6.6v1.8A.73.73,0,0,1,405,672Zm-1.2-1.1h.6v-.6h-.6Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M396.19,679.72a.65.65,0,0,1-.6-.6.55.55,0,0,1,.3-.5l.9-.5a1,1,0,0,0,.6-.8,1,1,0,0,0-.5-.8,1.89,1.89,0,0,1-1-1.9,2,2,0,0,1,1.5-1.8l.1-.1a.6.6,0,0,1,.5,1.1l-.1.1a1.08,1.08,0,0,0-.8.9.79.79,0,0,0,.5.8,2.23,2.23,0,0,1,1,1.8,2.09,2.09,0,0,1-1.2,1.8l-.9.5C396.39,679.62,396.29,679.72,396.19,679.72Z",
  transform: "translate(-395.59 -663.32)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M403.79,679.72a.65.65,0,0,1-.6-.6.55.55,0,0,1,.3-.5l.9-.5a1,1,0,0,0,.6-.8,1,1,0,0,0-.5-.8,1.89,1.89,0,0,1-1-1.9,2,2,0,0,1,1.5-1.8l.1-.1a.6.6,0,0,1,.5,1.1l-.1.1a1.08,1.08,0,0,0-.8.9.79.79,0,0,0,.5.8,2.23,2.23,0,0,1,1,1.8,2.09,2.09,0,0,1-1.2,1.8l-.9.5C404,679.62,403.89,679.72,403.79,679.72Z",
  transform: "translate(-395.59 -663.32)"
});

function SvgIconTcOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTcOn);
export default __webpack_public_path__ + "static/media/icon-tc-on.cdbf2ed7.svg";
export { ForwardRef as ReactComponent };